<template>
  <TwinPanel title="Set your new password">
    <template v-slot:form>
      <b-form :novalidate="true" class="form" @submit="onSubmit">
        <b-alert variant="danger" :show="error">
          {{ error }}
        </b-alert>

        <b-form-group label="New Password" label-for="newPassword1">
          <b-form-input
            id="newPassword1"
            v-model="user.new_password_1"
            type="password"
            :state="passwordValid(user.new_password_1)"
          />
          <b-form-invalid-feedback :state="passwordValid(user.new_password_1)">
            Your password must be at least 10 characters. Safety first!
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-show="!passwordMatch() && passwordMatch() != null"
                                   :state="passwordMatch()">
            These passwords must match.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Repeat New Password" label-for="newPassword2">
          <b-form-input
            id="newPassword2"
            v-model="user.new_password_2"
            type="password"
            :state="passwordMatch()"
          />
          <b-form-invalid-feedback :state="passwordMatch()">
            These passwords must match.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-button type="submit" variant="primary"
                  :pressed="submitting"
                  :disabled="submitting || !formValid() ">
          Reset your password
        </b-button>
      </b-form>
    </template>
    <template v-slot:text>
      <h4>
        Heurix is currently in Beta so let us know how we can improve things for you.
        You can <a href="mailto:info@heurix.io">email us</a> or use the feedback popup once
        you log in.
      </h4>
    </template>
  </TwinPanel>
</template>


<style lang="scss" scoped>
  .form {
    margin: 0 auto;
    max-width: 550px;

    input, button {
      height: 3em;
      width: 100%;
    }

    button:disabled, button {
      background-color: #ff583b;
      border-color: #ff583b;
    }
  }
</style>

<script>
  import apiMixin from "../../utils/api"
  import TwinPanel from "./utils/TwinPanel"

  export default {
    name: 'UserRegister',
    components: {TwinPanel},
    mixins: [apiMixin],
    props: {
      uid: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        user: {},
        error: null,
        submitting: false
      }
    },
    async created() {
      let maybeReroute = val => {
        if (val) {
          this.navigate('site.list')
        }
      }
      this.$store.watch(
        (state, getters) => getters['user/loggedIn'],
        (newValue) => {
          maybeReroute(newValue)
        },
      )
      maybeReroute(this.$store.getters['user/loggedIn'])
    },
    methods: {
      async onSubmit(e) {
        e.preventDefault()
        await this.withLoading(async () => {
          try {
            await this.put(`/api/users/reset-token/${this.uid}/${this.token}/`, this.user)
            await this.$store.dispatch('user/getDetails', this)
            this.navigate('site.list')
          } catch (e) {
            this.error = e.error
          }
        }, 'submitting')
      },
      formValid() {
        return this.passwordValid(this.user.new_password_1)
          && this.passwordValid(this.user.new_password_1)
          && this.passwordMatch()
      },
      passwordValid(pwd) {
        if (!pwd) {
          return null
        }
        return pwd.length >= 10
      },
      passwordMatch() {
        if (!this.user.new_password_2) {
          return null
        }
        return this.user.new_password_1 === this.user.new_password_2
      },
    }
  }
</script>
